import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { WorkersPage } from '@/features/rrhh/components/workers-page';

const searchSchema = z.object({
  worker: z.string().uuid().optional(),
});

export const Route = createFileRoute('/_app/rrhh/$clientId')({
  component: RrhhClientWorkersRoute,
  validateSearch: searchSchema,
});

function RrhhClientWorkersRoute() {
  const { clientId } = Route.useParams();
  const { worker } = Route.useSearch();
  return <WorkersPage clientId={clientId} initialWorkerId={worker} />;
}
